var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "side-panel",
      attrs: { elevation: "1", "data-testid": "side-panel" },
    },
    [
      _c(
        "v-tabs",
        {
          attrs: { grow: "" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("v-tab", { attrs: { "data-testid": "tab-sensors" } }, [
            _vm._v(_vm._s(_vm.$mpt(_vm.$t("tabs.sensors")))),
          ]),
          _vm._v(" "),
          _vm.captureRecordEnabled
            ? _c(
                "v-tab",
                { attrs: { "data-testid": "tab-capture-records" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("tabs.captureRecords")) +
                      "\n      "
                  ),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "offset-y": "",
                        left: "",
                        "content-class": "capture-add-menu",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var menuOn = ref.on
                              return [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var tooltipOn = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass:
                                                        "capture-tab-add-btn ml-1",
                                                      attrs: {
                                                        icon: "",
                                                        "x-small": "",
                                                        "data-testid":
                                                          "capture-tab-add-button",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                        },
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  Object.assign(
                                                    {},
                                                    tooltipOn,
                                                    menuOn
                                                  )
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { "x-small": "" },
                                                    },
                                                    [_vm._v("add")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("addTooltip"))),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        721619361
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        [
                          !_vm.hasFloorPlan
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "div",
                                              _vm._g(
                                                _vm._b({}, "div", attrs, false),
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    attrs: {
                                                      disabled: "",
                                                      "data-testid":
                                                        "capture-add-from-map",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-icon",
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          },
                                                          [_vm._v("place")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("addFromMap")
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3021920137
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("addFromMapDisabledTip"))
                                    ),
                                  ]),
                                ]
                              )
                            : _c(
                                "v-list-item",
                                {
                                  attrs: {
                                    "data-testid": "capture-add-from-map",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("capture-add-from-map")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("place"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(_vm.$t("addFromMap"))),
                                  ]),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            {
                              attrs: {
                                "data-testid": "capture-add-without-position",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit(
                                    "capture-add-without-position"
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-icon",
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("note_add"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(_vm.$t("addWithoutPosition"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-tab", { attrs: { "data-testid": "tab-ranking" } }, [
            _vm._v(_vm._s(_vm.$t("tabs.ranking"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          staticClass: "tabs-content",
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "v-tab-item",
            { staticClass: "pa-3" },
            [
              _c("floor-plan-item-list", {
                attrs: {
                  items: _vm.normalizedItems,
                  type: "sensor",
                  "drag-data-key": "itemId",
                },
                on: {
                  remove: function ($event) {
                    return _vm.$emit("remove", $event)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.captureRecordEnabled
            ? _c(
                "v-tab-item",
                { staticClass: "pa-3" },
                [
                  _c("capture-record-list", {
                    attrs: {
                      "capture-records": _vm.captureRecords,
                      "floor-plan-objects": _vm.floorPlanObjects,
                      "current-floor-plan-id": _vm.currentFloorPlanId,
                      "all-floor-plans": _vm.allFloorPlans,
                      sensors: _vm.sensors,
                      "data-testid": "capture-record-list",
                    },
                    on: {
                      edit: function ($event) {
                        return _vm.$emit("capture-edit", $event)
                      },
                      delete: function ($event) {
                        return _vm.$emit("capture-delete", $event)
                      },
                      unplace: function ($event) {
                        return _vm.$emit("capture-unplace", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { staticClass: "pa-3" },
            [
              _c("floor-plan-item-ranking", {
                ref: "itemRanking",
                attrs: {
                  items: _vm.normalizedItems,
                  type: "sensor",
                  "filter-label": _vm.detectionFilterLabel,
                  "place-name": _vm.placeName,
                  "floor-plan-name": _vm.floorPlanName,
                  "selected-month": _vm.selectedMonth,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isRankingTab
        ? _c("ranking-export-actions", {
            attrs: { exporting: _vm.exporting, disabled: !_vm.hasRankingData },
            on: {
              "export-image": _vm.handleExportImage,
              "export-csv": _vm.handleExportCsv,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }